export enum CemAssignmentPriority {
  Priority1 = '1',
  Priority2 = '2',
  Priority3 = '3',
}
